import React from "react";

interface FieldProps {
  label: string;
  value: string | null | undefined;
}

const Field: React.FC<FieldProps> = ({ label, value }) => (
  <div className="flex w-full flex-col gap-2">
    <span className="text-cream-800 dark:text-cream-400 text-sm font-medium">
      {label}
    </span>
    <span className="text-cream-950 dark:text-cream-100 font-medium">
      {value || "—"}
    </span>
  </div>
);

export default Field;
